import { getCurrentInstance } from 'vue'
import { computed } from 'vue'
import { getAppBaseConfig } from '@/storage/services/AppBaseConfigService'
import xreportstore from '@/xreports/store'
import hotelcemstore from '@/hotelcem/store'

// 访问vuex
export const useStore = () => {
  return getAppBaseConfig().appName === 'xreports' ? xreportstore : hotelcemstore
}

export const useMoudleFile = () => {
  return getAppBaseConfig().appName === 'xreports' ? 'common' : 'commentList'
}
// 访问router
export const useRouter = () => {
  const vm = getCurrentInstance()
  if (!vm) throw new Error('must be called in setup')
  return vm.proxy.$router
}
// 访问route
export const useRoute = () => {
  const vm = getCurrentInstance()
  if (!vm) throw new Error('must be called in setup')
  return vm.proxy.$route
}

/**
 * 访问vuex的getter
 * @param {string} module - vuex模块名或具体getter路径
 * @param {string[] | undefined} nameList - getter名列表, 为空时默认module入参为具体getter路径
 * @returns {object | getter} - 包含所有getter的对象或单个getter
 */
export const useGetter = (module, nameList) => {
  const store = useStore()
  if (!module) throw new Error('module is required')
  if (nameList) {
    const output = {}
    if (!Array.isArray(nameList)) throw new Error('nameList must be array')
    if (!nameList.length) throw new Error('nameList can not be empty')
    for (const item of nameList) {
      if (!item) continue
      output[item] = store.getters[`${module}/${item}`]
    }
    return output
  }

  return store.getters[module]
}

/**
 * 访问vuex的state
 * @param {string} module - vuex模块名或具体state路径
 * @param {string[] | undefined} nameList - state名列表, 为空时默认module入参为具体state路径
 * @returns {object | state} - 包含所有state的对象或单个state
 */
export const useState = (module, nameList) => {
  const store = useStore()
  if (!module) throw new Error('module is required')
  if (getAppBaseConfig().appName === 'xreports' && module === 'commentList') module = 'common'
  if (nameList) {
    const output = {}
    if (!Array.isArray(nameList)) throw new Error('nameList must be array')
    if (!nameList.length) throw new Error('nameList can not be empty')
    for (const item of nameList) {
      if (!item) continue
      output[item] = computed(() => store.state[module][item])
    }
    return output
  }

  return computed(() => store.state[module])
}
